import React, { Component } from "react";
import { AsyncPaginate } from 'react-select-async-paginate';
import { callBackendAPI, handleFormValidation, generateSource } from './../../helpers/common';
import { STATUS_SUCCESS, PROJECT_MANAGER_TYPE, SUPERVISOR_TYPE } from './../../config/global_constants';
import { translate } from './../../helpers/intl_helpers';


export default class AddManagerSupervisor extends Component {
	constructor(props) {
		super(props)

		this.state = {
			errors: {},
			fields: {},
			submitted: false,
			bulkErrors: null,
			modalType: this.props.modalType
		};

		this.closeModal = this.closeModal.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.loadOptions 				= this.loadOptions.bind(this);
	}

	componentDidMount() {
		this.getWorkOrderList();
		window.document.body.classList.add("modal-open");
		window.document.body.classList.add("overflow-hidden");
	}

	/**
	* For get work order listing
	*/
	getWorkOrderList = () =>{
		const { modalType } = this.state;
		const { weekData } = this.props;
		/** Call API for work order list */
		callBackendAPI([{ model: 'on_call', method: 'get-manager-supervisor', type: modalType, start_date: weekData?.from, end_date: weekData?.to }]).then(response => {
			if(response.success && response.data[0].status === STATUS_SUCCESS && response.data[0].result){
				if (modalType === PROJECT_MANAGER_TYPE || modalType === SUPERVISOR_TYPE) {
					this.setState(prevState => ({
						fields: {
							...prevState.fields,
							[modalType]: response.data[0].result
						}
					}));
				}
			}
		}).catch(err => console.log(err));
	}// end getWorkOrderList()

	/**
	* For load project manager options
	*
	* @param inputValue		as 	search term
	* @param loadedOptions	as 	old options array
	* @param page			as 	page count
	*
	* @return json
	*/
	async loadOptions(inputValue, loadedOptions, { page }) {
		try {
			/** Generate source for cancel token */
			this.source = generateSource();
			const { weekData } = this.props;

			let response = await callBackendAPI([{ model: 'calendar', method: 'employeeList', onCallSchedule: true, scheduleUserType: this.state.modalType, is_project_manager: true, current_page: page, emp_name: inputValue ? inputValue : '', start_date: weekData?.from, end_date: weekData?.to }], this.source);

			let resData = response && response.data && response.data[0] ? response.data[0] : {};
			let result = resData.result ? resData.result : [];
			let recordsTotal = resData.recordsTotal ? resData.recordsTotal : 0;
			let completeArray = result.concat(loadedOptions);

			return {
				options: result,
				hasMore: completeArray.length === recordsTotal ? false : true,
				additional: { page: page + 1 },
			}

		} catch (error) {
			console.error('Error loading options:', error);
			return {
				options: [],
				hasMore: false,
				additional: { page: page },
			};
		}
	}

	/**
	* For manage form submit event
	*
	* @param e 	as 	current form object
	*
	* @return null
	*/
	handleFormSubmit(e) {
		e.preventDefault();

		const { project_manager, supervisor } = this.state.fields;
		const { weekData } = this.props;
		this.setState({submitted: true});

		/** Api Requested Data **/
		let params = [{
			model: 'on_call',
			method: 'add-manager-supervisor',
			start_date: weekData?.from,
			end_date: weekData?.to,
			manager_id: project_manager?.value || "",
			supervisor_id: supervisor?.value || "",
			type: this.state.modalType || ""
		}];

		/** Validation Rules **/
		let validations = {};

		if (this.state.modalType === PROJECT_MANAGER_TYPE) {
			validations.project_manager = {
				label: translate('project_manager', translate('on_call.project_manager')),
				rules: ["select"]
			};
		} else {
			validations.supervisor = {
				label: translate('supervisor', translate('on_call.supervisor')),
				rules: ["select"]
			};
		}


		/** Handle validation and api response **/
		handleFormValidation(validations, this.state.fields, params, true, true, true).then(async (response) => {
			if (!response.success) {
				if (response.errors && response.data) {
					this.setState({ errors: response.errors, submitted: false });
				} else if (response.errors) {
					this.setState({ errors: response.errors, submitted: false })
				}
			} else {
				/** Hide loader */
				this.closeModal();
				this.props.getOnCallList();
			}

		}).catch(err => console.log(err));
	}

	/** Manage input change event */
	handleChange = (fieldName) => (fieldVal) => {
		this.setState((prevState) => {
			const newFields = { ...prevState.fields, [fieldName]: fieldVal };

			return { fields: newFields };
		});
	};

	/**
	* For hide model
	*
	* @return null
	*/
	closeModal() {
		window.document.body.classList.remove("modal-open");
		window.document.body.classList.remove("overflow-hidden");

		this.props.requestAddModal(false);
	}// end closeModal()


	render() {
		const { submitted, fields, errors, modalType } = this.state;
		const { weekData } = this.props;

		return <>
			<div
				className="modal fade on-call-modal d-block show"
				id="addPersonModalLabel"
				tabIndex={-1}
				aria-labelledby="add-personModalLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog modal-dialog-centered">
					<div className="modal-content">
						<div className="modal-header">
							<h2 className="modal-title fs-5" id="add-personModalLabel">{modalType === PROJECT_MANAGER_TYPE ? translate("on_call.set_project_manager") : translate("on_call.set_supervisor")}</h2>
							<button type="button" className="btn-close"  aria-label="Close" onClick={() => this.closeModal()}></button>
						</div>
						<form className="request-field" onSubmit={(event) => this.handleFormSubmit(event, 'AddProjectSupervisor')} noValidate>
							<div className="modal-body">
								<div className="sp-week-banner">
									<p className="sp-week-range"><strong className='me-1'>{translate("on_call.week")} </strong> <span id="sp-week-label">{weekData?.from?.toLocaleDateString()} - {weekData?.to?.toLocaleDateString()}</span></p>
									<p className="sp-week-note" id="sp-week-note"> <strong className='me-1'>{translate("on_call.note")}</strong>{modalType === PROJECT_MANAGER_TYPE ?translate("on_call.project_manager_can_only_be_set_for_week_views") : translate("on_call.supervisor_can_only_be_set_for_week_views")} </p>
								</div>

								{modalType === PROJECT_MANAGER_TYPE ?
									<div className="row filter-box top-0 mt-3">
										<div className="col-md-12">
											<div className="form-group">
												<label className="mb-1 form-label">{translate("on_call.project_manager")}</label>
												<AsyncPaginate
													className='custom-react-select '
													loadOptions={this.loadOptions}
													value={fields?.project_manager ? fields?.project_manager : null}
													onChange={this.handleChange("project_manager")}
													isClearable={true}
													placeholder={translate("on_call.select_manager")}
													additional={{ page: 1 }}
												/>
												<span className="error text-danger">{errors["project_manager"]}</span>
												<span className="error text-danger">{errors["manager_id"]}</span>
											</div>
										</div>
									</div>
								:
									<div className="row filter-box top-0 mt-3">
										<div className="col-md-12">
											<div className="form-group">
												<label className="mb-1 form-label">{translate("on_call.supervisor")}</label>
												<AsyncPaginate
													className='custom-react-select '
													loadOptions={this.loadOptions}
													value={fields?.supervisor ? fields?.supervisor : null}
													onChange={this.handleChange("supervisor")}
													isClearable={true}
													placeholder={translate("on_call.select_supervisor")}
													additional={{ page: 1 }}
												/>
												<span className="error text-danger">{errors["supervisor"]}</span>
												<span className="error text-danger">{errors["supervisor_id"]}</span>
											</div>
										</div>
									</div>
								}
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-outline" data-bs-dismiss="modal" onClick={() => this.closeModal()}>{translate("system.close")}</button>
								{/* <button type="button" className="btn btn-fill">Save changes</button> */}

								<button type={submitted ? "button" : "submit"} className="btn btn-fill">
									{translate("system.save_changes")} {submitted && <i className="spinner-border spinner-border-sm  ms-3"/>}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div className="modal-backdrop fade show"></div>
		</>
	}
}